export const eyebrow = (text: string): string => `<span class="eyebrow">${text}</span>`;

/** Decorative gradient mesh; upgraded to the WebGL flow gradient in heroes and CTA bands. */
export const mesh = (className = ''): string =>
  `<div class="mesh ${className}" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></div>`;
